import {connect} from 'react-redux';
import QueueListScreen from '../../components/screens/QueueListScreen';
import {getQueueList, filterQueueList, filterQueueListByCurrentPeriod, removeSupporterFromQueue, setSupporterToPeriodAndRemoveFromQueue, toggleQueueCollapse} from '../../actions/queueListAction';

const mapStateToProps = state => {
    return {
        queues: state.queueList.queues,
        availableCurrentPeriods: state.queueList.availableCurrentPeriods,
        currentPeriodsFilter: state.queueList.currentPeriodsFilter,
        searchString: state.queueList.searchString
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getQueueList: () => {
            dispatch(getQueueList())
        },
        filterQueueList: (searchString) => {
            dispatch(filterQueueList(searchString))
        },
        removeSupporterFromQueue: (supporterId) => {
            dispatch(removeSupporterFromQueue(supporterId))
        },
        setSupporterToPeriodAndRemoveFromQueue: (supporterId) => {
            dispatch(setSupporterToPeriodAndRemoveFromQueue(supporterId))
        },
        toggleQueueCollapse: (queueId) => {
            dispatch(toggleQueueCollapse(queueId))
        },
        currentPeriodFilterChange: (periods) => {
            dispatch(filterQueueListByCurrentPeriod(periods))
        }
    }
};

const QueueListScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(QueueListScreen);

export default QueueListScreenContainer;